<template>
    <div class="container body fix-footer">
        <div class="row justify-content-center">
            <div class="col-md-8 mt-5 mb-3">
                <div class="card">
                    <div class="card-header">
                        <h3>{{$t('pages.NewNews')}}</h3>
                    </div>
                    <div class="card-body">
                        <div class="alert alert-danger" v-if="error">
                            {{$t(error)}}
                        </div>
                        <form @submit="submit">
                            <formly-form :form="form" :model="model" :fields="fields" ref="createNews"/>
                            <button type="submit" class="btn btn-primary">{{ $t('button.Save') }}</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import isLength from 'validator/lib/isLength';
  import { mapActions } from 'vuex';
  import {ERROR_MESSAGES, ROUTER_NAMES} from '../../constants';

  export default {
    name: 'CreateNews',
    data() {
      return {
        error: '',
        form: {},
        model: {
          title: '',
          body: '',
          short: '',
          status: 'published',
          type: 'news',
        },
        fields: [
          {
            key: 'title',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Title')
            },
            required: true,
            validators: {
              validTitle: {
                expression(field, model, next) {
                  next(isLength(model[field.key], { min: 3 }));
                },
                message: 'Nazov musi obsahovat aspoň 3 znaky'
              }
            }
          },
          {
            key: 'image',
            type: 'image',
            templateOptions: {
              label: this.$t('fields.Image')
            },
            required: false
          },
          {
            key: 'body',
            type: 'mce',
            templateOptions: {
              label: this.$t('fields.Content'),
            },
            required: true,
            validators: {
              validShort: {
                expression(field, model, next) {
                  next(isLength(model[field.key], {
                    min: 10
                  }));
                },
                message: this.$tc('validation.min', 10)
              }
            }
          },
          {
            key: 'short',
            type: 'mce',
            templateOptions: {
              label: this.$t('fields.Short'),
            },
            required: true,
            validators: {
              validShort: {
                expression(field, model, next) {
                  next(isLength(model[field.key], {
                    min: 3,
                    max: 300
                  }));
                },
                message: this.$t('validation.minMax', {
                  min: 3,
                  max: 300
                })
              }
            }
          },
          {
            key: 'status',
            type: 'multi-select',
            options: [
              {
                label: this.$t('news.options.draft'),
                value: 'draft'
              },
              {
                label: this.$t('news.options.published'),
                value: 'published'
              },
              {
                label: this.$t('news.options.archived'),
                value: 'archived'
              },
            ],
            templateOptions: {
              label: this.$t('fields.Status'),
              multiple: false,
              closeOnSelect: true
            },
            required: true,
          },
          {
            key: 'type',
            type: 'multi-select',
            options: [
              {
                label: this.$t('news.type.news'),
                value: 'news'
              },
              {
                label: this.$t('news.type.message'),
                value: 'message'
              },
            ],
            templateOptions: {
              label: this.$t('fields.newsType'),
              multiple: false,
              closeOnSelect: true
            },
            required: true,
          },
          {
            key: 'is_featured',
            type: 'checkbox',
            templateOptions: {
              label: this.$t('fields.SetAsTop'),
            }
          }
        ]
      };
    },
    methods: {
      ...mapActions(['createNews']),
      submit(e) {
        e.preventDefault();

        this.$refs.createNews.validate()
          .then(() => {
            if (!this.form.$valid) return;
            const data = {
              ...this.model,
              status: this.model.status.value,
              category: this.model.type.value,
              is_featured: !!this.model.is_featured,
            };
            this.createNews(data)
              .then(() => {
                this.$router.push({
                  name: ROUTER_NAMES.HOME
                });
              })
              .catch((e) => {
                this.error = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
              });
          });
      }
    }
  };
</script>

<style scoped>

</style>
